import React from "react";
import { FileUpload } from "primereact/fileupload";
import useLocalStore from "hooks/useLocalStore";
const baseURL = process.env.REACT_APP_API_PATH ?? "/api/";

export default function ImportFile({
  toastRef,
  onUploadStart,
  onUploadEnd,
  setImportModal = () => {},
  label,
  url,
  accept,
  disabled,
}) {
  const localStore = useLocalStore();

  const onBeforeSend = (event) => {
    const token = localStore.getToken();
    event.xhr.setRequestHeader("Authorization", `Bearer ${token}`);
  };

  const onUpload = () => {
    toastRef.current.show({
      severity: "success",
      summary: "Success",
      detail: "File Uploaded",
      life: 5000,
    });
    setImportModal(false);
    onUploadEnd();
  };

  const uploadError = (e) => {
    toastRef.current.show({
      severity: "error",
      summary: "Error",
      detail: e?.xhr?.response,
      life: 7000,
    });
    onUploadEnd();
  };

  return (
    <React.Fragment>
      <FileUpload
        mode="basic"
        name="file"
        url={`${baseURL}${url}`}
        accept={accept}
        maxFileSize={1000000}
        onUpload={onUpload}
        auto
        chooseLabel={label}
        onBeforeSend={onBeforeSend}
        onError={uploadError}
        disabled={disabled}
        onBeforeUpload={onUploadStart}
      />
    </React.Fragment>
  );
}
